import { Injectable } from '@angular/core';
import { FilterModel } from '../components/filter-checkbox-tree/filter-checkbox-tree.component';
import { ArrayHelper } from '../../../models/helpers/array-helper';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

    constructor() {
    }

    public static makeFilterModels<T>(values: T[],
                                      titleSelector: (value: T) => string | string[],
                                      existingFilters: FilterModel<T>[],
                                      undefinedValueTitle?: string): FilterModel<T>[] {
        let titles = this.mapValues(values, titleSelector);
        let filters = ArrayHelper.getDistinct(titles)
            .filter((value): value is string => value != null && !!value.trim())
            .sort((a, b) => a.localeCompare(b))
            .map(title => new FilterModel<T>(title,
                value => {
                    let selectedValue = titleSelector(value);
                    if (typeof selectedValue === 'string') return title == selectedValue;
                    if (!selectedValue) return false;
                    return selectedValue.includes(title);
                },
                this.shouldSelect(title, existingFilters)
            ));

        if (undefinedValueTitle && titles.some(value => !value)) {
            filters.unshift(new FilterModel<T>(undefinedValueTitle,
                v => {
                    let selectedValue = titleSelector(v);
                    if (!selectedValue) return true;
                    if (typeof selectedValue === 'string') return false;
                    return selectedValue.length == 0;
                },
                this.shouldSelect(undefinedValueTitle, existingFilters)));
        }
        return filters;
    }

    private static mapValues<T>(array: T[], selector: (value: T) => string | string[]): Array<string | null> {
        let result: Array<string | null> = [];
        for (let value of array) {
            let selectedValue = selector(value);
            if (typeof selectedValue === 'string') {
                result.push(selectedValue);
                continue;
            }
            if(!selectedValue) {
                result.push(null);
                continue;
            }
            if (selectedValue.length == 0) {
                result.push(null);
                continue;
            }
            for (let r of selectedValue) {
                result.push(r);
            }
        }
        return result;
    }

    public static shouldSelect<T>(title: string, existingFilters: FilterModel<T>[]): boolean {
        if (existingFilters == null || existingFilters.length == 0) return true;
        let existingFilter = existingFilters.find(filter => filter.name == title);
        if (existingFilter == null)
            return true;
        return existingFilter.selected;
    }

    public static combineFiltersWithOr<T>(filters: FilterModel<T>[]): (value: T) => boolean {
        return value => {
            for (let filter of filters) {
                if (filter.matches(value)) return true;
            }
            return false;
        };
    }
}
